module.exports = __webpack_public_path__ + "img/720.6c3e4ec0.svg";